// Set config.appId to the correct app id on load based on the path
const appType = 'appType';
export function getAppId(appId) {
    sessionStorage.setItem(appType, 'ev2');
    return appId;
}
//# sourceMappingURL=get_app_id.js.map